/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { Party } from './party.model';


export class DossierParties {
    dossierId?: string; // ecf001
    dossierCode?: string; // ecf001
    evolutionDescription?: string; // ecf001
    courtOfJustice?: string; // ecf001
    parties?: Party[]; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): DossierParties {
        if (!data) { return instance; }
        if (data.dossierId != null) {instance.dossierId = data.dossierId; }
        if (data.dossierCode != null) {instance.dossierCode = data.dossierCode; }
        if (data.evolutionDescription != null) {instance.evolutionDescription = data.evolutionDescription; }
        if (data.courtOfJustice != null) {instance.courtOfJustice = data.courtOfJustice; }
        if (data.parties != null) {
            instance.parties = [];
            ([].concat(data.parties)).forEach(occurrence => {
                instance.parties.push(new Party().fromJSON(occurrence)); // i3
            });
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return DossierParties.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: DossierParties) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return DossierParties.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: DossierParties): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
